import React from "react";
import { formatAppDate } from "../../helpers/date-formatter";
import ArchiveIcon from "../../assets/ArchiveIcon";
import EditIcon from "../../assets/EditIcon";
import DeleteIcon from "../../assets/DeleteIcon";
import ActivateIcon from "../../assets/ActivateIcon";
import DataTable from "../table/DataTable";
import { MediaCell } from "../table/DataTableCell";
import StatusBadge from "../table/StatusBadge";
import ActionGroup, { ActionButton } from "../table/ActionGroup";

function NewsTable({ news, onDelete, onEdit, onArchive, isArchive }) {
  const columns = [
    {
      key: "news",
      label: "News",
      render: (newsItem) => (
        <MediaCell
          src={newsItem.imageUrl}
          alt={newsItem.title}
          title={newsItem.title}
          subtitle={newsItem.content}
        />
      ),
    },
    {
      key: "status",
      label: "Status",
      width: "160px",
      render: () => (
        <StatusBadge
          active={!isArchive}
          label={isArchive ? "Archived" : "Active"}
          variant={isArchive ? "archived" : "active"}
        />
      ),
    },
    {
      key: "createdOn",
      label: "Created On",
      width: "160px",
      render: (newsItem) => formatAppDate(newsItem.createdOn),
    },
    {
      key: "actions",
      label: "Actions",
      align: "right",
      width: "140px",
      render: (newsItem) => (
        <ActionGroup>
          <ActionButton
            color={isArchive ? "green" : "orange"}
            onClick={() => onArchive(newsItem)}
            title={isArchive ? "Activate" : "Archive"}
          >
            {isArchive ? <ActivateIcon /> : <ArchiveIcon />}
          </ActionButton>
          <ActionButton color="blue" onClick={() => onEdit(newsItem)} title="Edit">
            <EditIcon />
          </ActionButton>
          <ActionButton color="red" onClick={() => onDelete(newsItem)} title="Delete">
            <DeleteIcon />
          </ActionButton>
        </ActionGroup>
      ),
    },
  ];

  return (
    <DataTable
      columns={columns}
      rows={news}
      rowKey="id"
      minWidth="760px"
      emptyMessage="No news found."
    />
  );
}

export default NewsTable;
